var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _g2, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishResult21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 931.49 350",
    style: {
      enableBackground: "new 0 0 931.49 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#FFCA04;}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:#2A73DC;}\n\t.st8{opacity:0.25;fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{opacity:0.2;fill:url(#SVGID_9_);}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{opacity:0.5;fill:url(#SVGID_11_);}\n\t.st13{opacity:0.4;fill:url(#SVGID_12_);}\n\t.st14{fill:url(#SVGID_13_);}\n\t.st15{fill:url(#SVGID_14_);}\n\t.st16{fill:url(#SVGID_15_);}\n\t.st17{fill:url(#SVGID_16_);}\n\t.st18{fill:url(#SVGID_17_);}\n\t.st19{fill:url(#SVGID_18_);}\n\t.st20{fill:url(#SVGID_19_);}\n\t.st21{fill:url(#SVGID_20_);}\n\t.st22{fill:url(#SVGID_21_);}\n\t.st23{fill:url(#SVGID_22_);}\n\t.st24{fill:url(#SVGID_23_);}\n\t.st25{fill:url(#SVGID_24_);}\n\t.st26{fill:url(#SVGID_25_);}\n\t.st27{fill:url(#SVGID_26_);}\n\t.st28{fill:url(#SVGID_27_);}\n\t.st29{opacity:0.6;}\n\t.st30{fill:#FFFFFF;}\n\t.st31{opacity:0.8;fill:url(#SVGID_28_);}\n\t.st32{opacity:0.5;fill:url(#SVGID_29_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.9408,
    y1: 21.1105,
    x2: 462.19,
    y2: 186.7452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.52,115.61h-0.02c-14.93-9.97-33.17-17.29-59.58-13.1c-3.69,0.59-231.09,37.85-343.95,56.37l-0.2,0.02 c21.85-16.21,49.43-22.44,61.75-25.59c28.6-7.31,223.2-47.08,223.2-47.08s38.14-7.7,46.26-23.94C592.1,46.06,578.29,0,578.29,0 C623.34,20.49,656.52,115.61,656.52,115.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.5479,
    y1: 195.7246,
    x2: -205.705,
    y2: 196.9173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#426EF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4975,
    style: {
      stopColor: "#20449A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6576,
    style: {
      stopColor: "#163880"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D46"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M931.49,161.94c0,0-39.97,3.74-79.69,7.46c-1.86,0.17-3.72,0.36-5.58,0.52c-34.05,3.22-66.41,6.9-71.77,7.48 c-5.21,0.56-17.95,3.35-30.49,7.02c20.26-2.8,40.16-2.77,51.78-2.4c1.65,0.05,1.93,2.39,0.34,2.82 c-14.3,3.95-36.48,12.22-52.56,23.61c-20.7,14.64-25.25,16.4-60.83,28.51c-35.59,12.12-131.52,10.86-188.05,11.12 c-56.55,0.24-152.47-13.13-152.47-13.13s-145.44-27.99-149.44-28.53c-8.34-1.12-18.04-1.02-26.42,0.54 c-4.86,0.9-9.27,2.3-12.71,4.26c-9.34,5.3-37.11,40.88-54.78,69.41c-17.67,28.51-72.21,64.88-89.62,68.65 c-17.41,3.79-4.79-9.09-4.79-9.09c36.6-13.37,60.58-72.7,64.12-81.53c3.54-8.83,22.96-28.02,28.26-37.11 c5.31-9.09,4.04-33.57,3.54-45.18c-0.51-11.61-19.43-45.77-25.99-52c-14.52-13.76-16.41-23.72-25.76-38.36 c-9.34-14.64-47.8-42.86-47.8-42.86c42.76,3.25,120.69,85.98,121.43,88.23c0.76,2.27,20.05,23.32,34.84,32.59 c14.79,9.27,33.74,5.08,33.74,5.08s401.22-65.78,406.13-66.55c27.58-4.38,46.26,3.81,61.54,14.43 c15.28,10.61,68.35,39.34,79.38,40.26C748.88,158.12,931.49,161.94,931.49,161.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.6194,
    y1: 199.425,
    x2: 479.6194,
    y2: 317.5443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D8C90"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M796.08,184.85c-14.3,3.94-36.48,12.22-52.56,23.61c-20.7,14.64-25.25,16.4-60.83,28.51 c-5.26,1.79-11.86,3.3-19.46,4.55c-2.3,0.37-4.69,0.73-7.16,1.07c-1.15,0.17-2.3,0.3-3.49,0.46c-2.52,0.32-5.11,0.61-7.77,0.88 c-1.18,0.12-2.39,0.24-3.6,0.36c-2.84,0.27-5.77,0.52-8.75,0.76c-1.22,0.08-2.44,0.19-3.67,0.27c-42.86,3.1-97.01,2.61-134.16,2.78 c-56.55,0.24-152.47-13.13-152.47-13.13s-145.44-27.99-149.44-28.53c-8.34-1.12-18.04-1.02-26.42,0.54 c-19.17,1.18-45.03-4.65-51.02-15.57c-2.61-4.74-4.55-11.74,3.45-18.55c10.83-9.17,40.14-4.18,40.14-4.18 c7.6,14.37,28.19,12.42,28.19,12.42l659.14-11.17c-34.05,3.22-66.4,6.9-71.77,7.48c-5.21,0.56-17.95,3.35-30.49,7.02 c20.26-2.79,40.16-2.78,51.78-2.4C797.38,182.08,797.67,184.41,796.08,184.85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M763.4,179.07c-5.69,1.42-12.57,3.35-19.44,5.36c5.75-0.8,11.47-1.35,16.99-1.76 c-8.66,11.57-24.33,20.85-51.66,23.05c-84.83,6.84-378.86-0.71-462.86-7.46c-37.19-3-56.03-10.17-65.47-17.23 c3.6,0.3,6.13,0.07,6.13,0.07l580.13-9.83C766.21,173.91,764.96,176.53,763.4,179.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 702.6623,
    y1: 205.9929,
    x2: 869.5449,
    y2: 200.9864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D8C90"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M796.08,184.85c-5.35,1.47-11.81,3.55-18.65,6.18c-11.41,4.4-23.86,10.31-33.91,17.43 c-17.19,12.17-23.25,15.43-45.2,23.13c-4.48,1.57-9.61,3.33-15.64,5.38c-5.26,1.79-11.86,3.3-19.46,4.55 c14.55-11.29,10.2-24.05-4.82-37.58c-0.58-0.51-1.12-1.03-1.62-1.56c-0.25-0.27-0.51-0.52-0.76-0.8c-0.73-0.78-1.4-1.57-2.01-2.39 c-0.1-0.12-0.2-0.25-0.29-0.37c-0.3-0.41-0.59-0.83-0.88-1.24l-0.07-0.1c-0.29-0.42-0.56-0.83-0.81-1.25 c-1.84-3.49-2.18-4.26-2.47-5.04c-3.69-9.61-1.44-17.9-1.44-17.9l0.03-0.02l198.14-3.35c-31.39,2.96-61.34,6.33-70.02,7.29 c-0.74,0.08-1.32,0.14-1.74,0.19c-5.21,0.56-17.95,3.35-30.49,7.02c20.26-2.79,40.16-2.78,51.78-2.4 C797.38,182.08,797.67,184.41,796.08,184.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.9551,
    y1: 139.9473,
    x2: 224.948,
    y2: 183.9332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250.47,159.29c-29.34,4.81-50.55,8.29-57.33,9.39l-16.75-6.19c0,0,43.3-16.82,44.17-16.82 C221.39,145.66,250.47,159.29,250.47,159.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.6681,
    y1: 250.1988,
    x2: 256.7339,
    y2: 198.1667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M287,224.37l-35.32,12.81c0,0-22.61-15.5-45.86-18.65l10.39-7.7v-0.02C235.17,214.42,262.58,219.68,287,224.37 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M931.49,161.94c0,0-43.81,4.1-85.27,7.99l-41.17,0.69l-121.33,2.06l-496.64,8.41c0,0-24.82,2.34-30.02-17.11 c14.79,9.27,33.74,5.08,33.74,5.08s401.22-65.78,406.13-66.55c27.58-4.38,46.26,3.81,61.54,14.43c9.98,6.94,36.13,21.61,56.11,31.2 c10.58,5.08,19.44,8.73,23.27,9.05c1.4,0.12,5.55,0.27,11.73,0.47C792.19,159.03,931.49,161.94,931.49,161.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 544.2723,
    y1: 189.0897,
    x2: 544.2723,
    y2: 80.9297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5259,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M931.49,161.94c0,0-43.81,4.1-85.27,7.99l-41.17,0.69l-121.33,2.06l-496.64,8.41c0,0-24.82,2.34-30.02-17.11 c14.79,9.27,33.74,5.08,33.74,5.08s401.22-65.78,406.13-66.55c27.58-4.38,46.26,3.81,61.54,14.43c9.98,6.94,36.13,21.61,56.11,31.2 c10.58,5.08,19.44,8.73,23.27,9.05c1.4,0.12,5.55,0.27,11.73,0.47C792.19,159.03,931.49,161.94,931.49,161.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.1252,
    y1: 269.9391,
    x2: 604.6114,
    y2: 180.9673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5025,
    style: {
      stopColor: "#2558B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M634.27,202.37c-49.95,84.62-171.11,77.12-142.34,64.07c3-1.36,6.07-3.04,9.22-5.01 c20.45-12.73,43.24-36.73,57.38-52.83c9.05-10.33,22.29-15.97,36.02-15.41l27.01,1.1l8.57,0.35 C633.98,194.81,636.25,199.03,634.27,202.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.6785,
    y1: 184.0282,
    x2: 534.7073,
    y2: 305.5839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5259,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M634.27,202.37c-49.95,84.62-171.11,77.12-142.34,64.07c3-1.36,6.07-3.04,9.22-5.01 c48.56,13.95,104.67-67.77,104.67-67.77l24.31,0.99C633.98,194.81,636.25,199.03,634.27,202.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.3418,
    y1: 304.7105,
    x2: 388.7256,
    y2: 224.2485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M450.55,246.4c-0.9,0-18.58,6.97-36.77,16.87c-9.73,5.28-19.6,11.41-27.14,17.75 c-11.12,9.36-34.52,32.12-63.34,24.32c0,0,18.85-18.34,21.71-22.32c7.8-10.9,9.61-23.96,1.49-30.19 c-8.11-6.23-28.48-15.67-28.48-15.67l21.91-2.64l9.17,0.98c0,0,0,0,0.02,0l96.64,10.39l4.59,0.49 C450.43,246.38,450.48,246.38,450.55,246.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 668.2185,
    y1: 185.4732,
    x2: 697.1696,
    y2: 185.4732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D8C90"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M683.75,172.69c-0.85,6.18,5.41,14.79,11.3,18c2.44,1.33,2.87,4.64,0.82,6.51l-0.01,0.01 c-0.77,0.7-1.79,1.09-2.83,1.04c-27.34-1.32-24.74-25.3-24.74-25.3L683.75,172.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 695.2828,
    y1: 192.5945,
    x2: 668.6438,
    y2: 213.8154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D8C90"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M697.67,215.56c2.91,8.04-1.74,16.89-9.83,19.65c-1.64,0.56-3.36,1.15-5.15,1.76 c-5.26,1.79-11.86,3.3-19.46,4.55c14.55-11.29,10.2-24.05-4.82-37.58c-0.58-0.51-1.12-1.03-1.62-1.56 c-0.25-0.27-0.51-0.52-0.76-0.8c-0.73-0.78-1.4-1.57-2.01-2.39c-0.1-0.12-0.2-0.25-0.29-0.37c-0.3-0.41-0.61-0.83-0.88-1.24 l-0.07-0.1c-0.29-0.42-0.56-0.83-0.81-1.25c-1.84-3.49-2.18-4.26-2.47-5.04c0,0,13.58,16.32,41.68,18.71 C694.59,210.2,696.57,212.53,697.67,215.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 633.3132,
    y1: 205.6359,
    x2: 633.3132,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M628.47,176.4c-6.09-31.07,11.01-55.38,11.01-55.38s-6.53,12.66-7.04,41.97c-0.2,11.47,1.92,18.44,4.44,28.5 C636.87,191.49,630.48,186.65,628.47,176.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.7428,
    y1: 205.6359,
    x2: 607.7428,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M602.52,175.22c-6.56-33.49,11.86-59.68,11.86-59.68s-7.04,13.65-7.59,45.24 c-0.22,12.36,2.07,19.87,4.79,30.71C611.58,191.49,604.68,186.27,602.52,175.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 582.1724,
    y1: 205.6359,
    x2: 582.1724,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M576.82,174.82c-6.73-34.32,12.16-61.16,12.16-61.16s-7.21,13.99-7.78,46.36 c-0.22,12.66,2.12,20.37,4.91,31.47C586.1,191.49,579.04,186.14,576.82,174.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 556.602,
    y1: 205.6359,
    x2: 556.602,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M551.38,175.22c-6.56-33.49,11.86-59.68,11.86-59.68s-7.04,13.65-7.59,45.24 c-0.22,12.36,2.07,19.87,4.79,30.71C560.44,191.49,553.54,186.27,551.38,175.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 531.0316,
    y1: 205.6359,
    x2: 531.0316,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M525.98,175.77c-6.34-32.36,11.46-57.66,11.46-57.66s-6.8,13.19-7.33,43.71c-0.21,11.94,2,19.2,4.62,29.67 C534.74,191.49,528.08,186.45,525.98,175.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.4612,
    y1: 205.6359,
    x2: 505.4612,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M500.69,176.63c-5.99-30.59,10.83-54.51,10.83-54.51s-6.43,12.47-6.93,41.32 c-0.2,11.29,1.89,18.15,4.37,28.05C508.97,191.49,502.67,186.72,500.69,176.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.8909,
    y1: 205.6359,
    x2: 479.8909,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M480.09,176.24c0.77,5.05,2.04,9.64,3.44,15.24c0,0-6.01-4.56-7.92-14.22c-0.06-0.32-0.12-0.63-0.18-0.95 c-4.43-24.57,6.38-44.47,9.65-49.8c0.11-0.02,0.21-0.03,0.3-0.05c-1.57,3.82-5.65,15.89-6.03,38.17 C479.29,169.05,479.58,172.75,480.09,176.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.3205,
    y1: 205.6359,
    x2: 454.3205,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M454.51,177.25c0.72,4.71,1.9,9,3.22,14.24c0,0-5.62-4.26-7.39-13.28c-0.06-0.3-0.11-0.59-0.17-0.89 c-4.13-22.94,5.95-41.52,9.02-46.5c0.1-0.01,0.2-0.03,0.28-0.04c-1.47,3.57-5.28,14.84-5.63,35.64 C453.76,170.54,454.03,173.99,454.51,177.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.0136,
    y1: 205.6359,
    x2: 429.0136,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M429.19,178.34c0.66,4.35,1.76,8.32,2.97,13.15c0,0-5.19-3.94-6.83-12.26c-0.05-0.27-0.1-0.55-0.16-0.82 c-3.82-21.19,5.5-38.36,8.33-42.96c0.09-0.01,0.18-0.03,0.26-0.04c-1.36,3.3-4.87,13.71-5.2,32.92 C428.5,172.13,428.74,175.33,429.19,178.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.7068,
    y1: 205.6359,
    x2: 403.7068,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M403.87,179.1c0.63,4.1,1.66,7.83,2.8,12.39c0,0-4.89-3.71-6.43-11.55c-0.05-0.26-0.1-0.52-0.15-0.77 c-3.6-19.96,5.18-36.13,7.85-40.47c0.09-0.01,0.17-0.02,0.25-0.04c-1.28,3.11-4.59,12.92-4.9,31.01 C403.22,173.25,403.45,176.26,403.87,179.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.3999,
    y1: 205.6359,
    x2: 378.3999,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M378.55,179.97c0.58,3.81,1.54,7.28,2.6,11.52c0,0-4.54-3.45-5.98-10.74c-0.05-0.24-0.09-0.48-0.14-0.72 c-3.34-18.56,4.82-33.6,7.29-37.63c0.08-0.01,0.16-0.02,0.23-0.03c-1.19,2.89-4.27,12.01-4.55,28.84 C377.95,174.54,378.16,177.33,378.55,179.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.093,
    y1: 205.6359,
    x2: 353.093,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M353.23,181.03c0.53,3.46,1.4,6.61,2.36,10.46c0,0-4.13-3.13-5.43-9.75c-0.04-0.22-0.08-0.44-0.12-0.65 c-3.04-16.85,4.37-30.5,6.62-34.16c0.07-0.01,0.15-0.02,0.21-0.03c-1.08,2.62-3.88,10.9-4.14,26.18 C352.68,176.1,352.88,178.64,353.23,181.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.7861,
    y1: 205.6359,
    x2: 327.7861,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M327.91,181.87c0.49,3.18,1.29,6.08,2.17,9.62c0,0-3.8-2.88-5-8.97c-0.04-0.2-0.08-0.4-0.11-0.6 c-2.79-15.5,4.02-28.06,6.09-31.43c0.07-0.01,0.13-0.02,0.19-0.03c-0.99,2.41-3.57,10.03-3.8,24.09 C327.41,177.33,327.59,179.66,327.91,181.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.4793,
    y1: 205.6359,
    x2: 302.4793,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M302.59,182.77c0.44,2.89,1.17,5.51,1.97,8.72c0,0-3.44-2.61-4.53-8.13c-0.03-0.18-0.07-0.36-0.1-0.54 c-2.53-14.05,3.65-25.42,5.52-28.47c0.06-0.01,0.12-0.02,0.17-0.03c-0.9,2.19-3.23,9.09-3.45,21.82 C302.14,178.66,302.3,180.78,302.59,182.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.1724,
    y1: 205.6359,
    x2: 277.1724,
    y2: 151.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4285F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001D63"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M277.27,183.86c0.39,2.52,1.02,4.82,1.72,7.62c0,0-3.01-2.28-3.96-7.11c-0.03-0.16-0.06-0.32-0.09-0.48 c-2.21-12.28,3.19-22.23,4.83-24.9c0.05-0.01,0.11-0.02,0.15-0.02c-0.79,1.91-2.83,7.95-3.01,19.08 C276.87,180.27,277.02,182.12,277.27,183.86z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M632.46,245.05c-1.22,0.08-2.44,0.19-3.67,0.27c-2.06-7.24-2.3-14.74,0.39-20.8c0.59-1.32,2,0.42,2.05,1.2 C631.7,232.27,631.21,238.6,632.46,245.05z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M644.81,243.93c-1.18,0.12-2.39,0.24-3.6,0.36c-2.83-6.48-4.5-13.37-4.16-20.32 c0.08-1.83,2.18-0.29,2.42,0.66C641.16,231.37,642.68,237.77,644.81,243.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M656.07,242.59c-1.15,0.17-2.3,0.3-3.49,0.46c-3.3-6.92-5.5-14.35-4.67-21.36c0.2-1.54,1.71-0.2,1.98,0.54 C652.36,229.09,653.88,235.93,656.07,242.59z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.0279,
    y1: 151.2481,
    x2: 773.0209,
    y2: 179.8465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5259,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M805.05,170.62l-121.33,2.06c-0.02-0.03-0.03-0.07-0.03-0.1c-0.07-0.46-0.78-24.77,22.64-24.94 c2.72-0.02,5.47,0.15,8.26,0.51c10.58,5.08,19.44,8.73,23.27,9.05c1.4,0.12,5.55,0.27,11.73,0.47 C767.29,163.85,785.89,170.61,805.05,170.62z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 717.18,
    cy: 168.61,
    r: 9.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.18,
    cy: 168.61,
    r: 6.47
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 791.7055,
    y1: 179.8057,
    x2: 739.4592,
    y2: 188.2666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D8C90"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M796.08,184.85c-5.35,1.47-11.81,3.55-18.65,6.18c-10.15-0.49-28.5,3.5-34.23,4.96 c-10.02,2.54-18.02-4.82-13.11-10.51c9.91-11.49,46.11-8.26,46.11-8.26c-0.74,0.08-1.32,0.14-1.74,0.19 c-5.21,0.56-17.95,3.35-30.49,7.02c20.26-2.79,40.16-2.78,51.78-2.4C797.38,182.08,797.67,184.41,796.08,184.85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishResult21);
export default __webpack_public_path__ + "static/media/fish-result-21.db01a7677246a5b283fcdeeb16e38c8e.svg";
export { ForwardRef as ReactComponent };